import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import store from "./Redux/store";
import reportWebVitals from "./reportWebVitals";
import { AdminAuthProvider } from "./ContextAPI/AdminContex";
import KioskAuthProvider from "./ContextAPI/KisokContext";
import { KanchiOMAuthProvider } from "./ContextAPI/KanchiKisok";
import { BrowserRouter } from "react-router-dom";



const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AdminAuthProvider>
        <KioskAuthProvider>
          <KanchiOMAuthProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
        </KanchiOMAuthProvider>
        </KioskAuthProvider>
      </AdminAuthProvider>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
